export const SHOW_QUOTA_PAYWALL = 'SHOW_QUOTA_PAYWALL';
export const HIDE_QUOTA_PAYWALL = 'HIDE_QUOTA_PAYWALL';
export const OPEN_PLANS = 'OPEN_PLANS';
export const SET_BUY_MORE = 'SET_BUY_MORE';
export const SET_PLAN_INFO = 'SET_PLAN_INFO';
export const HIDE_SESSION_ENDED = 'HIDE_SESSION_ENDED';
export const REQUEST_TUTOR_RESTART = 'REQUEST_TUTOR_RESTART';
